/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { ChatStreamRequest } from '../models/ChatStreamRequest';
import type { ChatViewResponse } from '../models/ChatViewResponse';
import type { ComparisonSummaryRequest } from '../models/ComparisonSummaryRequest';
import type { ComparisonSummaryResponse } from '../models/ComparisonSummaryResponse';
import type { CreateThreadRequest } from '../models/CreateThreadRequest';
import type { DiscoveryPlanHighlightsRequest } from '../models/DiscoveryPlanHighlightsRequest';
import type { DiscoveryPlanHighlightsResponse } from '../models/DiscoveryPlanHighlightsResponse';
import type { ThreadResponse } from '../models/ThreadResponse';
import type { UiEventBatchRequest } from '../models/UiEventBatchRequest';
import type { UiEventBatchResponse } from '../models/UiEventBatchResponse';

export class AgentShoppingConsultantService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Get or create the shopping_consultant thread for this enrollment period.
   * @param requestBody
   * @returns ThreadResponse Successful Response
   * @throws ApiError
   */
  public createOrGetThreadApiV2AgentsShoppingConsultantChannelsPost(
    requestBody: CreateThreadRequest
  ): CancelablePromise<ThreadResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/v2/agents/shopping_consultant/channels',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Ingest a batch of UI Driver events for this onboarding period. Each event becomes one actor='ai_driver_fe' audit row; handler dispatch produces artifact ids (empty in G2; populated in G3/G4).
   * Persist a batch of UI Driver events for the given enrollment
   * period. Each event becomes one `actor='ai_driver_fe'` audit row;
   * handler dispatch produces artifact ids (G2: empty; G3/G4 will fill
   * these in). Transaction-atomic across the batch — Invariant 14.
   *
   * The batch shape (`{onboarding_period_id, events: [...]}`) matches
   * the FE buffer-then-submit demo: queue 1..N events client-side, send
   * once. Use a one-element list for the single-event case.
   * @param onboardingPeriodId
   * @param requestBody
   * @returns UiEventBatchResponse Successful Response
   * @throws ApiError
   */
  public ingestUiEventsApiV2AgentsShoppingConsultantChannelsOnboardingPeriodIdUiEventPost(
    onboardingPeriodId: string,
    requestBody: UiEventBatchRequest
  ): CancelablePromise<UiEventBatchResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/v2/agents/shopping_consultant/channels/{onboarding_period_id}/ui_event',
      path: {
        onboarding_period_id: onboardingPeriodId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Stream a chat turn for this onboarding period.
   * PRODUCTION chat stream. Body type is `ChatStreamRequest` — no
   * `user_context` field exists on it, so an authenticated-user override is
   * structurally unparseable here. User identity is the authenticated user,
   * UNLESS a gated impersonation override is authorized (via the
   * `authorize_impersonation` dependency): an OmnipotentAdmin + break-glass
   * secret (M10), or a staff caller the monolith cleared on the target's
   * `discovery-ai-chat/impersonation-access` (employer opt-in), may ground on
   * another employee. The dependency runs before the stream, so it 403s cleanly.
   * @param onboardingPeriodId
   * @param requestBody
   * @returns any Successful Response
   * @throws ApiError
   */
  public chatStreamSseApiV2AgentsShoppingConsultantChannelsOnboardingPeriodIdChatStreamSsePost(
    onboardingPeriodId: string,
    requestBody: ChatStreamRequest
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/v2/agents/shopping_consultant/channels/{onboarding_period_id}/chat_stream_sse',
      path: {
        onboarding_period_id: onboardingPeriodId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Load the chat history (FE-audience composition) for this onboarding period.
   * Internal-only — return the FE-audience composition for this
   * thread: structured cards + dialogue + episode banners (no
   * compaction). Used by the BO chat thread + future production
   * chat surfaces.
   *
   * Distinct from `/composed_view` (LLM-shape compacted blocks). The
   * two endpoints serve different consumers.
   *
   * 404 if the thread doesn't exist.
   * @param onboardingPeriodId
   * @returns ChatViewResponse Successful Response
   * @throws ApiError
   */
  public getComposedChatViewApiV2AgentsShoppingConsultantChannelsOnboardingPeriodIdComposedChatViewGet(
    onboardingPeriodId: string
  ): CancelablePromise<ChatViewResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/v2/agents/shopping_consultant/channels/{onboarding_period_id}/composed_chat_view',
      path: {
        onboarding_period_id: onboardingPeriodId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * One-shot plan highlights for a discovery plan (per-cluster ranks).
   * PRODUCTION one-shot highlights for a discovery plan. Care preferences are
   * the authenticated principal's (or the subject the route's read guard already
   * authorized) — the body type carries no preferences override, so a
   * client-supplied slice is structurally unparseable here (Invariant A6).
   *
   * This depends on the SAME `authorize_read_subject` the route's
   * `authorize_onboarding_period_read` gate does, so FastAPI's per-request
   * dependency cache guarantees the subject the preferences are loaded for is
   * exactly the subject that was authorized — the two can never disagree.
   * @param onboardingPeriodId
   * @param requestBody
   * @returns DiscoveryPlanHighlightsResponse Successful Response
   * @throws ApiError
   */
  public planHighlightsEndpointApiV2AgentsShoppingConsultantPlanHighlightsOnboardingPeriodIdPost(
    onboardingPeriodId: string,
    requestBody: DiscoveryPlanHighlightsRequest
  ): CancelablePromise<DiscoveryPlanHighlightsResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/v2/agents/shopping_consultant/plan_highlights/{onboarding_period_id}',
      path: {
        onboarding_period_id: onboardingPeriodId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Ori's comparison of the plans open in Compare (table notes + chat summary).
   * PRODUCTION one-shot comparison. Same subject resolution as
   * `plan_highlights_endpoint`: no preferences override on the body type.
   * @param onboardingPeriodId
   * @param requestBody
   * @returns ComparisonSummaryResponse Successful Response
   * @throws ApiError
   */
  public comparisonSummaryEndpointApiV2AgentsShoppingConsultantComparisonSummaryOnboardingPeriodIdPost(
    onboardingPeriodId: string,
    requestBody: ComparisonSummaryRequest
  ): CancelablePromise<ComparisonSummaryResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/v2/agents/shopping_consultant/comparison_summary/{onboarding_period_id}',
      path: {
        onboarding_period_id: onboardingPeriodId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
